import { Link } from "react-router-dom";
import { events, latestUpdates } from "@/mocks/events";
import StatusBadge from "@/components/base/StatusBadge";

export default function LatestBoard() {
  const featured = events[0];

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
        <div className="mb-8 flex flex-col justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-accent-600">
              LIVE BOARD
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              通报速览
            </h2>
          </div>
          <Link
            to="/events"
            className="inline-flex items-center gap-1.5 self-start text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            查看全部事件
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          <div className="border-t border-background-200">
            {latestUpdates.map((item) => (
              <Link
                key={`${item.eventId}-${item.time}`}
                to={`/events/${item.eventId}`}
                className="group flex items-start gap-4 border-b border-background-200 py-4 transition-colors hover:bg-background-100/70"
              >
                <div className="flex w-16 shrink-0 flex-col items-start pt-0.5">
                  <span className="font-heading text-sm font-bold text-accent-600">
                    {item.time}
                  </span>
                </div>
                <div className="min-w-0">
                  <div className="mb-1 flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-verified-badge-line"></i>
                      </span>
                      {item.actor}
                    </span>
                  </div>
                  <p className="text-sm leading-relaxed text-foreground-700 group-hover:text-foreground-950">
                    {item.text}
                  </p>
                </div>
                <span className="ml-auto hidden h-5 w-5 shrink-0 items-center justify-center text-foreground-400 group-hover:text-primary-600 md:flex">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </Link>
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">重点追踪</h3>
              <StatusBadge status={featured.status} />
            </div>
            <Link to={`/events/${featured.id}`} className="group block">
              <div className="h-40 w-full overflow-hidden rounded-md bg-background-200">
                <img
                  src={featured.cover}
                  alt={`${featured.title} 时间线配图`}
                  title={`${featured.title} · 官方通报追踪`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h4 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-accent-600">
                {featured.title}
              </h4>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
            <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
              <span>{featured.timeline.length} 条时间线节点</span>
              <Link
                to={`/events/${featured.id}`}
                className="inline-flex items-center gap-1 font-medium text-primary-700 hover:text-primary-600"
              >
                查看完整还原
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}